import { useSimulationModelsIndexCompare } from "../simulation/useSimulationModelsIndexCompare";

export const useAssetClassAnalysisIndexCompare = (params: {
  storageKey?: string;
  data1Id?: string;
  data2Id?: string;
  data3Id?: string;
}) => {
  return useSimulationModelsIndexCompare(params);
};
